'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to perform action on click as well as on enter key for buttons AND
 * anchors
 */
    .directive('capAction', ['$parse', function ($parse) {
        return function (scope, element, attr) {
            // get directive value (expected to be a function call)
            var fn = $parse(attr['capAction']);

            // build handler to invoke function call
            var handler = function (event) {
                scope.$apply(function () {
                    fn(scope, {$event: event})
                });
            };

            // bind handler to elements as needed
            element.bind('click', handler);
            element.bind('keyup', function (event) {
                if (event.keyCode == 13 || event.keyCode == 32)
                    handler(event);
            })
        }
    }]);